import { useMemo } from 'react';
import { Table } from 'tea-component';

import type { SortBy, SortableColumn } from 'tea-component/lib/table/addons';

const { sortable } = Table.addons;

export default function useTableAddons(options: {
  sortInfos: SortBy<any>[];
  onSortChange: (value: SortBy<any>[]) => void;
}) {
  const { sortInfos, onSortChange } = options || {};

  const sortableAddon = useMemo(() => {
    const sortableColumns: SortableColumn<IStudioManagementKeyIssue>[] = [
      {
        key: 'category',
        prefer: 'desc',
        sorter: (a, b) => {
          const aCategory = a?.category;
          const bCategory = b?.category;
          if (!aCategory && !bCategory) return 0;
          if (!aCategory) return 1;
          if (!bCategory) return -1;
          return aCategory?.toLowerCase()?.localeCompare(bCategory?.toLowerCase());
        },
      },
      {
        key: 'risk_rating',
        prefer: 'desc',
        sorter: (a, b): number => {
          const aRisk = Number.parseInt(a?.risk_rating, 10);
          const bRisk = Number.parseInt(b?.risk_rating, 10);
          if (Number.isNaN(aRisk) && Number.isNaN(bRisk)) return 0;
          if (Number.isNaN(aRisk)) return 1;
          if (Number.isNaN(bRisk)) return -1;
          return aRisk - bRisk;
        },
      },
    ];
    return sortable({
      columns: sortableColumns,
      value: sortInfos,
      onChange: onSortChange,
    });
  }, [sortInfos, onSortChange]);

  const addons = useMemo(() => [sortableAddon], [sortableAddon]);

  return { addons };
}
